import { IScheduleModal } from '@/types/schedules'

interface DataTypeFunctions {
  [key: string]: () => object
}

const frequencyProps = {
  repeatType: '',
  dateType: '',
  ordinal: '',
  weekday: '',
  monthlyOpt: '',
}

const buildOnlyOnceData = (schedule: IScheduleModal) => {
  return {
    ...frequencyProps,
    repeatType: schedule.repeatType,
  }
}

const buildDailyData = (schedule: IScheduleModal) => {
  return {
    ...frequencyProps,
    repeatType: schedule.repeatType,
    dateType: schedule.dateType,
  }
}

const buildWeeklyData = (schedule: IScheduleModal) => {
  return {
    ...frequencyProps,
    repeatType: schedule.repeatType,
    fixedDay: schedule.fixedDay,
  }
}

const buildMonthlyData = (schedule: IScheduleModal) => {
  return schedule.monthlyOpt === '0'
    ? {
        ...frequencyProps,
        repeatType: schedule.repeatType,
        dateType: schedule.dateType,
        fixedDay: schedule.fixedDay,
        monthlyOpt: schedule.monthlyOpt,
      }
    : {
        ...frequencyProps,
        repeatType: schedule.repeatType,
        ordinal: schedule.ordinal,
        weekday: schedule.weekday,
        monthlyOpt: schedule.monthlyOpt,
      }
}

export const getRecurrenceProps = (schedule: IScheduleModal) => {
  const dataTypes: DataTypeFunctions = {
    OnlyOnce: () => buildOnlyOnceData(schedule),
    Daily: () => buildDailyData(schedule),
    Weekly: () => buildWeeklyData(schedule),
    Monthly: () => buildMonthlyData(schedule),
  }
  return dataTypes[schedule.repeatType]()
}

export const formatSchedule = (schedule: IScheduleModal) => {
  const recurrenceProps = getRecurrenceProps(schedule)

  return {
    ...recurrenceProps,
    name: schedule.name,
    startDay: schedule.startDay,
    runningTime: schedule.runningTime,
    timezone: schedule.timezone,
    format: 'NA',
    dateFormat: 'yyyy-MM-dd',
    subscribeFtpTriggerFile: schedule.subscribeFtpTriggerFile,
  }
}

export const validateSchedule = (schedule: IScheduleModal) => {
  const recurrenceProps = getRecurrenceProps(schedule)

  return {
    ...recurrenceProps,
    name: schedule.name,
    startDay: schedule.startDay,
    runningTime: schedule.runningTime,
    timezone: schedule.timezone,
    subscribeFtpTriggerFile: schedule.subscribeFtpTriggerFile,
  }
}
